const mobileMenu = () => {

    let menuWrap = document.querySelector('.header-top');
    let listParentItems = document.querySelectorAll('.nav-list_parent');
    
    menuWrap.addEventListener('click', function( e ) {
        let target = e.target;

        if( 
            target.closest('svg') 
            && 
            target.closest('svg').classList.contains('icon-menu') 
            || 
            target.classList.contains('icon-menu') 
        ) 
        {
            menuWrap.classList.add('header-top_mob');

        } else if( 
            target.closest('svg') 
            && 
            target.closest('svg').classList.contains('icon-menu_close')
            || 
            target.classList.contains('icon-menu_close') 
        ) 
        {
            menuWrap.classList.remove('header-top_mob');   
        }
    });

    for( let i = 0; i < listParentItems.length; i++ ) {
        listParentItems[i].addEventListener('click', function(e) {
            if( menuWrap.classList.contains('header-top_mob') ) {
                
                let target = e.target;
                let subList = target.nextElementSibling;
                 
                if (!target.closest('.sub-list.active')) {
                    e.preventDefault();
                    subList.classList.toggle('active');
                }
            }
        })
    }

}

export default mobileMenu;